<template>
  <div
    class="flex border-b-[1px] border-solid border-[#4c5658] text-[15px] text-[#828585] min-h-[60px] md:min-h-[90px] items-center"
  >
    <div class="flex-1">
      Photo
    </div>
    <div>
      <div v-if="avatar" class="flex gap-3 items-center">
        <Avatar :rounded="true" :src="avatar" size="large" />

        <button
          type="button"
          class="text-accent-400 cursor-pointer p-4 pr-0"
          @click="deleteAvatar"
        >
          Delete
        </button>
      </div>
      <div v-else-if="gravatar" class="flex gap-3 items-center">
        <img :src="gravatar" class="rounded-full size-[50px]" />
        <button
          type="button"
          class="text-accent-400 cursor-pointer p-4 pr-0"
          @click="deleteGravatar"
        >
          Delete
        </button>
      </div>
      <div v-else class="flex gap-3 items-center">
        <div v-if="isLoading"><Spinner class="size-6" /></div>
        <div v-else class="flex">
          <label
            for="avatar"
            class="flex items-center justify-center size-[50px] transition bg-[#3b4040] hover:bg-[#475252] text-[#bcbcbc] rounded-full cursor-pointer"
          >
            <span class="block text-[28px] pointer-events-none">
              +
            </span>
          </label>
          <label for="avatar" class="text-accent-400 cursor-pointer p-4 pr-0"
            >Edit</label
          >
          <input
            id="avatar"
            class="hidden"
            type="file"
            name="avatar"
            accept="image/jpeg, image/png"
            @change="uploadAvatar"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import Spinner from '@ui/components/Spinner.vue';
import { Avatar } from '@ui/components/avatar';

export default {
  components: {
    Spinner,
    Avatar,
  },

  setup() {
    const store = useStore();
    const isLoading = ref(false);
    const avatar = computed(() => store.getters['user/account/getAvatarUrl']);

    const gravatar = computed(
      () => store.getters['user/account/getGravatarUrl']
    );

    return {
      avatar,
      gravatar,
      isLoading,
    };
  },

  methods: {
    // The input field has changed
    uploadAvatar(event) {
      const fileList = event.target.files;
      const file = fileList[0];
      this.uploadFile(file);
    },

    // Upload a local file to the storage
    uploadFile(file) {
      const reader = new FileReader();
      const self = this;
      reader.onload = e => {
        const image = e.target.result;
        self.sendImage(image);
      };
      reader.readAsDataURL(file);
    },

    sendImage(image) {
      this.isLoading = true;

      this.$store
        .dispatch('user/account/uploadAvatar', { image })
        .then(response => {
          const { message } = response.data;
          this.$store.dispatch('application/notifications/createInfo', {
            text: message,
          });
        })
        .catch(error => {
          const { detail } = error.response.data;
          if (detail) {
            this.$store.dispatch('application/notifications/createError', {
              text: detail,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    deleteAvatar() {
      this.$store
        .dispatch('user/account/deleteAvatar')
        .then(response => {
          const { message } = response.data;
          this.$store.dispatch('application/notifications/createInfo', {
            text: message,
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    deleteGravatar() {
      this.$store
        .dispatch('user/account/deleteGravatar')
        .then(response => {
          const { message } = response.data;
          this.$store.dispatch('application/notifications/createInfo', {
            text: message,
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>
